<template>
<lanseedForm v-model:open="opend" :data="props.data" :rules="rules" @change="submit">
</lanseedForm>
</template>
<script setup lang="ts">
import {defineProps,watch,defineEmits,ref} from 'vue'
import lanseedForm from '@/components/lanseed/form.vue'
const props=defineProps({
  data:Object,open:{type:Boolean,default:false}
})
const emit=defineEmits(['change','update:open'])
const opend=ref<Boolean>(false)
const submit=(e:Object)=>{
  emit('change',e)
}
const rules=ref<Object>({
    title:{name:'标题',required:true},
    sub:{name:'描述'},
    pic:{name:'图片',domtype:'img'},
    icon:{name:'图标',domtype:'img'},
    url:{name:'链接',placehoolder:'链接地址'},
    orders:{name:'排序',domtype:'number'},
    contents:{name:'内容',domtype:'editor'}
  })
watch(()=>[props.open,opend.value],(e)=>{
  opend.value=e[0]
  emit('update:open',e[1])
})
</script>
